const LogRocket = require('logrocket')

function init(containerId) {
  LogRocket.init(containerId)
}

function identify(user) {
  LogRocket.identify(user.contactId, {
    name: user.name || '',
    email: user.email || '',
  })
}

module.exports = {
  init,
  identify,
}
